













































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
    components: {
    },
    ...mapGetters(["accountBook"])
})
export default class AmountCurrency extends Vue {
    @Prop({ type: Object })
    modalData?: ModalData;

    tableList: ModalData | null = null
    mounted() {
        if (this.modalData) this.tableList = this.modalData
    }
    @Watch("modalData")
    modalDataChange(val: ModalData) {
        this.tableList = val
    }
    // 刷新数据
    fetchData() {
        Vue.axios
            .post(`subjects/findcurrency`, {
                accountBookId: this.$store.state.accountBook.id
            })
            .then(res => {
                this.tableList = res.data
            });
    }

    old: string = ""
    setOld(e: any) {
        this.old = e.target.value;
        e.target.select()
    }

    // 失去焦点 保存数据接口
    blurPoints(num: any, e: any) {
        if (e.target.value != this.old) {
            Vue.axios
                .post(`subjects/modifybalance`, num)
                .then(res => {
                    this.$message.success("修改成功")
                    this.fetchData()
                })
                .catch(res => {
                    this.$message.error("修改失败")
                    this.fetchData()
                });        }
    }

}
